exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#top-leaderboard-ad-anchor {\n        position: sticky;\n        top: 0;\n        z-index: 1004;\n        width: 100%;\n    }", ""]);

// exports
